import { parseMimeType } from '@scalar/helpers/http/mime-type';
import { getResolvedRef } from '../helpers/get-resolved-ref.js';
/** Select an explicit example without confusing false, zero, null, or empty text with absence. */
export const getExampleValue = (input) => {
    const example = getResolvedRef(input);
    if (example?.serializedValue !== undefined) {
        return { source: 'serialized', value: example.serializedValue };
    }
    if (example?.dataValue !== undefined) {
        return { source: 'data', value: example.dataValue };
    }
    if (example?.value !== undefined) {
        return { source: 'value', value: example.value };
    }
    // externalValue is fetched by the bundler; until then it is not an inline payload.
    return undefined;
};
/** Preserve explicit wire text for any media type, or serialize structured JSON data. */
export const getExplicitExampleText = (example, contentType, indent) => {
    if (example?.source === 'serialized') {
        return example.value;
    }
    const { essence, subtype } = parseMimeType(contentType);
    if (example?.source === 'data' && (essence === 'application/json' || subtype.endsWith('+json'))) {
        return JSON.stringify(example.value, null, indent);
    }
    return undefined;
};
